
import Fotter from "@/components/Fotter.vue";
import Header from "@/components/Header.vue";
import { defineComponent } from "vue";

export default defineComponent({
    name: "DefaultLayout",
    components: { Fotter, Header },
});
